import queryString from 'query-string'
import { useLocation } from 'react-router-dom'

const defaultOptions = { parseNumbers: true, parseBooleans: true }

const useQueryString = (opts = defaultOptions) => queryString.parse(useLocation().search, opts)

export default useQueryString
